export const fileBase64ToBlob = (base64Data, contentType = "image/png") => {
  var sliceSize = 1024;
  var byteCharacters = window.atob(base64Data.split(",")[1]);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
};

// 文件下载
export const fileDownload = (file, filename, isUrl) => {
  const a = document.createElement("a"); //创建一个a标签
  a.download = filename || file.name;
  const href = isUrl ? file : URL.createObjectURL(file); //获取url
  a.href = href;
  a.target = "_blank";
  a.click();
  if (!isUrl) URL.revokeObjectURL(href);
};

// base64转文件格式
export const fileBase64ToFile = async (dataUrl, filename) => {
  const arr = dataUrl.split(",");
  const mine = (arr[0].match(/:(.*?);/) || [])[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mine });
};
